import BotLandingPage from './views/BotLandingPage.vue';
import PortfolioLandingPage from './views/PortfolioLandingPage.vue';
import ProjectsPage from './views/ProjectsPage.vue';
import { createRouter, createWebHistory } from 'vue-router'
import TermsPage from './views/TermsPage.vue';
import PrivacyPolicyPage from './views/PrivacyPolicyPage.vue';
import DiscordPage from './views/DiscordPage.vue';
import CallbackPage from './views/CallbackPage.vue';
import DashboardPage from './views/DashboardPage.vue';
import ConfigurationPage from './views/ConfigurationPage.vue';
import FormChild from './views/FormChild.vue';
import NotFoundPage from './views/NotFoundPage.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: PortfolioLandingPage,
    },
    {
        path: '/projets',
        name: 'Projets',
        component: ProjectsPage,
    },
    {
        path: '/bot',
        name: 'Bot',
        component: BotLandingPage,
    },
    {
        path: '/bot/privacy',
        name: 'Privacy Policy',
        component: PrivacyPolicyPage,
    },
    {
        path: '/bot/terms',
        name: 'Terms of Services',
        component: TermsPage,
    },
    {
        path: '/bot/discord',
        name: 'Discord',
        component: DiscordPage
    },
    {
        path: '/discord',
        redirect: '/bot/discord'
    },
    {
        path: '/bot/callback',
        name: 'Callback',
        component: CallbackPage
    },
    {
        path: '/bot/dashboard',
        name: 'Dashboard',
        component: DashboardPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/bot/configuration',
        name: 'Configuration',
        component: ConfigurationPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/bot/games',
        name: 'Games',
        component: FormChild,
        meta: { requiresAuth: true }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFoundPage
    },
];


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const title = to.name; // Fallback title if none is provided
    let pageTitle = '10-4';

    // Only add suffix for bot section pages
    if (title != undefined && title != 'Home' && title != 'Callback' && title != 'Bot' && title != 'Projets') {
        pageTitle += ' - ' + title;
    }

    document.title = pageTitle;

    const isLoggedIn = !!localStorage.getItem('10-4-Token');

    // Only require authentication for /bot/* routes with requiresAuth meta
    if (to.path.startsWith('/bot') && to.matched.some(record => record.meta.requiresAuth)) {
        if (!isLoggedIn) {
            // If not logged in, redirect to the bot landing page
            next({ name: 'Bot' });
        } else {
            // If logged in, continue to the page
            next();
        }
    } else {
        // For routes that don't require authentication, just continue
        next();
    }
});

export default router